module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_moere_og_romsdal_neg.51574397.svg";